import { getData } from '@/utils/apiHelper.js';
import {
  csvExportRequestConfig,
  normalizeCsvExportError,
  triggerCsvDownload,
} from '@/utils/csvExportDownload.js';

/**
 * Used to download csv files.
 * @param {string} downloadUrl url for downloading data.
 * @param {object} downloadParams request param for downloading data.
 * @param {string} fileName name of file.
 */
async function downloadCsvFile(downloadUrl, downloadParams, fileName, requiredHeaders) {
  try {
    const downloadRes = await getData(`${downloadUrl}`, csvExportRequestConfig(downloadParams));
    await triggerCsvDownload(downloadRes.data, fileName, requiredHeaders);
  } catch (error) {
    throw await normalizeCsvExportError(error);
  }
}

export default downloadCsvFile;
